import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import { getWordVersionTemplates, loadVersionWordTemplates } from "../../store/wordProccessing";
import NotesPopover from "../../../comman/NotesPopover";

const WordVersionHistory = (props) => {
    const { selectedTemp, handleVersionViewTemp, handlePreviewTemplate, handleWordTemplateLock } = props;

    const [tempHistory, setTempHistory] = useState([]);
    const [tempId, setTempId] = useState(0);

    const wordVersionTemplatesSelector = useSelector(getWordVersionTemplates);
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedTemp?.templateId > 0) {
            dispatch(loadVersionWordTemplates(selectedTemp.templateId));
        } else {
            setTempHistory([]);
        }
    }, [selectedTemp]);

    useEffect(() => {
        if (wordVersionTemplatesSelector.length > 0) {
            const oldVersionTemplates = wordVersionTemplatesSelector.filter(x => x.id !== selectedTemp.id);
            setTempHistory(oldVersionTemplates);
        }
    }, [wordVersionTemplatesSelector]);

    const handleResetSelection = () => {
        setTempId(0);
        handleVersionViewTemp(null);
    };

    const handleSelectVerTemplate = (item) => {
        if (tempId === item.id) {
            handleResetSelection();
        } else {
            setTempId(item.id);
            handleVersionViewTemp(item);
        }
    };

    return (
        <div className="table-responsive">
            <table className="table table-striped align-items-center table-flush">
                <thead>
                    <tr>
                        <th style={{ width: "100px" }}>ID</th>
                        <th>Created</th>
                        <th>Added By</th>
                        <th>Report</th>
                        <th>Notes</th>
                    </tr>
                </thead>
                <tbody>
                    {tempHistory.length === 0 ? (
                        <tr>
                            <td colSpan={5} className="text-center" style={{ padding: "30px", color: "#64748b", fontWeight: 550 }}>
                                <i className="fa fa-info-circle" aria-hidden="true" style={{ marginRight: "6px" }} />
                                No previous version history found for this report.
                            </td>
                        </tr>
                    ) : (
                        tempHistory.map((item, key) => (
                            <tr 
                                key={item.id} 
                                className={`rt-msg-row ${tempId === item.id ? "selected-row" : ""}`}
                                onClick={() => handleSelectVerTemplate(item)}
                                style={{ cursor: "pointer" }}
                                title={tempId === item.id ? "Click to deselect version" : "Click to select version"}
                            >
                                <td style={{ verticalAlign: "top" }}>
                                    <span className="rt-msg-id-cell-span" style={{ fontWeight: 600 }}>
                                        {tempId === item.id && (
                                            <i className="fa fa-check-circle selected-icon" style={{ marginRight: "6px" }} />
                                        )}
                                        #{item.id}
                                    </span>
                                </td>
                                <td>
                                    <div className="rt-msg-time">
                                        <span className="rt-msg-time-date">
                                            <Moment format="MMM D, YYYY">{item.createdDateTime}</Moment>
                                        </span>
                                        <span className="rt-msg-time-subtext" style={{ paddingLeft: 0, fontSize: "13px", color: "#64748b" }}>
                                            <Moment format="h:mm a">{item.createdDateTime}</Moment>
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <div className="wf-name-cell">
                                        <span className="wf-name-avatar">
                                            {(item.templateType || "System").split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase()}
                                        </span>
                                        <div className="wf-name-meta">
                                            <span className="wf-name-main">{item.templateType || "System"}</span>
                                            <span className="wf-name-title">Author</span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="rt-form-cell-wrapper">
                                        <div>
                                            <button
                                                type="button"
                                                className="rt-form-name-link"
                                                onClick={() => handlePreviewTemplate && handlePreviewTemplate(item)}
                                                title="Click to view version preview"
                                            >
                                                <span className="rt-form-name-text">{item.templateName}</span>
                                                <span className="rt-editor-version-tag" style={{ marginLeft: "8px" }}>V{item.version}</span>
                                            </button>
                                        </div>
                                        <div className="rt-status-tags-wrapper" style={{ marginTop: "4px" }}>
                                            <span className={`rt-form-status-tag ${item.isEdit ? "is-pending" : "is-updated"}`}>
                                                {item.isEdit ? "Unlocked" : "Locked"}
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    {item.notes ? (
                                        <NotesPopover notes={item.notes} placement={key === 0 ? "bottom" : "top"} />
                                    ) : (
                                        <span className="wf-empty-value">No notes</span>
                                    )}
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default WordVersionHistory;